/* eslint-disable indent */
import { http } from 'optilit-action-creators';

export const api = (name, data) => http({ call: name, data });

export const omit = () => {};

export const sleep = ms => new Promise(res => setTimeout(res, ms));
export const filterSortingStrategy = items =>
  items.sort((a, b) =>
    a.label !== b.label ? (a.label < b.label ? -1 : 1) : 0
  );

export const resolveImagePath = articleID =>
  `${process.env.REACT_APP_BASE_IMAGE_PATH_LARGE}${articleID}.jpg`;

export const createSourceObject = ({ order, payment }) => {
  let sourceObject;

  switch (payment.type) {
    case 'card':
      sourceObject = {
        type: payment.type,
        amount: order.order_amount,
        currency: order.order_currency,
        flow: payment.flow,
      };
      break;
    default:
      throw new Error('Unknown Payment method.');
  }

  return sourceObject;
};

export const paymentMethods = {
  card: {
    name: 'Kreditkarte',
    flow: 'none',
  },
};

export const mapFormValuesToOrder = values => {
  const customer = {};
  customer.customer_invoice_address = values.customer_invoice_address;
  customer.customer_delivery_address_id = null;
  customer.customer_delivery_address_alt =
    values.customer_delivery_address_eq_invoice_address === false;
  customer.customer_delivery_address = values.customer_delivery_address;
  customer.customer_email = values.customer_email;

  const order_information = {};

  order_information.delivery_date = values.order_information.partial_delivery
    ? 'Alle Artikel liefern sobald verfügbar (Teillieferungen).'
    : 'Alles zusammen versenden.';
  order_information.order_type = values.order_information.order_type_preview
    ? 'preview'
    : 'invoice';
  order_information.order_comment = values.order_information.order_comment;
  order_information.order_commission = {};
  order_information.order_commission.commission_required =
    values.order_information.order_commission.commission_required;
  order_information.order_commission.commission_text =
    values.order_information.order_commission.commission_text;

  const frame_configuration = {};

  frame_configuration.frame_formers = {};
  frame_configuration.frame_formers.formers_required =
    values.frame_configuration.frame_formers.formers_required;
  frame_configuration.frame_temples_imprint = {};

  frame_configuration.frame_temples_imprint.temples_imprint_required =
    values.frame_configuration.frame_temples_imprint.temples_imprint_required;
  frame_configuration.frame_temples_imprint.temples_imprint_text =
    values.frame_configuration.frame_temples_imprint.temples_imprint_text;

  return {
    customer,
    order_information,
    frame_configuration,
  };
};



// WEBPACK FOOTER //
// ./src/util/index.js